import { InjectionToken } from '@angular/core';
import { GithubSyncDialogData } from '@mode/github/contract';

export const GITHUB_SYNC_DIALOG_TOKEN = new InjectionToken<GithubSyncDialog>('GithubSyncDialogToken');

export interface GithubSyncDialog {
  open(data: GithubSyncDialogData): void;
  close(): void;
}
